import styled from 'styled-components'

export const TravelRuleTableWrapper = styled.div`
  padding-top: 10px;
`
